import { makeStyles } from '@mui/styles';

export const useActionsMenuItemStyles = makeStyles((theme) => ({
  dividerBefore: {
    borderTop: `1px solid ${theme.palette.divider}`,
    '&:first-child': {
      borderTop: 'none'
    }
  }
}));

export const useActionsButtonStyles = makeStyles(() => ({
  ActionsButton: (props: { variant?: 'dark' | 'light' }) => ({
    color: props.variant === 'light' ? undefined : 'white',
    height: 'auto',
    borderColor: props.variant === 'light' ? 'lightgrey' : 'transparent',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '4px',
    border: props.variant === 'light' ? '1px solid' : 'none',
    width: 'auto',
    paddingRight: '1rem',
    paddingLeft: '1rem',
    '&:hover': {
      color: '#3f4254',
      backgroundColor: '#fff',
      borderColor: props.variant === 'light' ? 'lightgrey' : 'transparent'
    }
  }),
  Mini: {
    color: 'white',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.05)'
    }
  }
}));
